import { LaunchSources, RoomTypes } from '~analytics/types';

import { sendLaunchShortAnswerEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchShortAnswerEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-short-answer';
  protected amplitudeEventFunction = sendLaunchShortAnswerEvent;

  constructor(
    settings: any,
    isRosteredRoom: boolean,
    launchSource: LaunchSources = LaunchSources.LaunchScreen
  ) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
        launch_source: launchSource,
        activity_require_names: settings.require_names,
        activity_one_attempt: settings.one_attempt,
        activity_allow_repeat_responses: settings.allow_repeat_responses,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
